import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/toaster";
import ErrorBoundary from "./components/ErrorBoundary";
import Landing from "./pages/Landing";
import LinksPage from "./pages/LinksPage";
import QRCodesPage from "./pages/QRCodesPage";
import DriversPage from "./pages/DriversPage";
import UserPortal from "./pages/UserPortal";
import UserLogin from "./pages/UserLogin";
import UserSignup from "./pages/UserSignup";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import RideTrackingPage from "./pages/RideTrackingPage";
import DriverProfilePage from "./pages/DriverProfilePage";
import DriverPortal from "./pages/DriverPortal";
import DriverSignup from "./pages/DriverSignup";
import DriverLogin from "./pages/DriverLogin";
import AdminPortal from "./pages/AdminPortal";
import AdminLogin from "./pages/AdminLogin";
import ForgotPassword from "./pages/ForgotPassword";
import DeliveryApp from "./pages/DeliveryApp";
import DeliveryTracking from "./pages/DeliveryTracking";

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/links" element={<LinksPage />} />
              <Route path="/qr-codes" element={<QRCodesPage />} />
              <Route path="/drivers" element={<DriversPage />} />
              
              {/* User Routes */}
              <Route path="/user" element={<UserPortal />} />
              <Route path="/user/login" element={<UserLogin />} />
              <Route path="/user/signup" element={<UserSignup />} />
              <Route path="/user/forgot-password" element={<ForgotPassword />} />
              <Route path="/user/payment/success" element={<PaymentSuccess />} />
              <Route path="/user/payment/cancel" element={<PaymentCancel />} />
              <Route path="/user/track/:rideId" element={<RideTrackingPage />} />
              <Route path="/user/driver/:driverId" element={<DriverProfilePage />} />
              
              {/* Driver Routes */}
              <Route path="/driver" element={<DriverPortal />} />
              <Route path="/driver/signup" element={<DriverSignup />} />
              <Route path="/driver/login" element={<DriverLogin />} />
              <Route path="/driver/forgot-password" element={<ForgotPassword />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminPortal />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              
              {/* Standalone Delivery App */}
              <Route path="/delivery-app" element={<DeliveryApp />} />
              <Route path="/delivery-app/track/:deliveryId" element={<DeliveryTracking />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </div>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
